import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from './fetcher/fetcher.service';
import { PaginationConfig } from '@cpak/consts';
import { SearchResponsePayload, SortOrder, SearchTarget } from '@cpak/adp-cpak-bff-service-models';
import { SearchPaksSortType } from '@cpak/adp-cpak-quotes-service-models';
import { SearchAccountsSortType } from '@cpak/adp-cpak-accounts-service-models';
import { SearchProductsSortType } from '@cpak/adp-cpak-products-service-models';
export interface SearchForTarget {
  search: string;
  target: SearchTarget;
  countryIds: string[];
  territoryIds?: string[];
  sort?: SearchPaksSortType | SearchAccountsSortType | SearchProductsSortType;
  sortOrder?: SortOrder;
  offset?: number;
  limit?: number;
  withQuotesOnly?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private fetcher: FetcherService) {}
  public getSearchResultForTarget({
    search,
    target,
    countryIds,
    territoryIds = [],
    sort = SearchPaksSortType.modifiedDate,
    sortOrder = SortOrder.asc,
    offset = PaginationConfig.startPage,
    limit = PaginationConfig.limit,
    withQuotesOnly = true,
  }: SearchForTarget): Observable<SearchResponsePayload | null> {
    return this.fetcher.get<SearchResponsePayload | null>(`/api/search`, {
      query: search,
      target,
      sort,
      sortOrder,
      limit,
      offset,
      countryIds,
      territoryIds,
      withQuotesOnly,
    });
  }

  public getAllSearchResults(
    search: string,
    countryId: string,
    territoryIds: string[],
    isAllTerritoriesSelected = true,
    limit = PaginationConfig.limitShort
  ): Observable<SearchResponsePayload | null> {
    return this.fetcher.get<SearchResponsePayload | null>(`/api/search`, {
      query: search,
      limit,
      countryIds: countryId,
      territoryIds,
      noTerritoriesSelected: !isAllTerritoriesSelected && territoryIds.length === 0,
    });
  }
}
